
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenRoleDefinition {

    authority: string;
    description: string;
    name: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genRoleDefinition: GenRoleDefinition);

    constructor( input?: GenRoleDefinition ) {
        if ( input && typeof input !== 'number' ) {
            this.authority = input.authority; // string [string]
            this.description = input.description; // string [string]
            this.name = input.name; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenRoleDefinition[] {
        if (arr && arr.map) {
          return arr.map(a => new GenRoleDefinition(a));
        } else {
          return [];
        }
    }
}

